/*
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ElTableModule } from '../cdk/table/table.module';
import { ElIconModule } from '../icon/icon.module';
import { ElTreeGridComponent } from './tree-grid.component';
import {
  ElTreeGridCellDefDirective,
  ElTreeGridFooterCellDefDirective,
  ElTreeGridFooterRowDefDirective,
  ElTreeGridHeaderCellDefDirective,
  ElTreeGridHeaderRowDefDirective,
  ElTreeGridRowDefDirective,
} from './tree-grid-def.component';
import {
  ElTreeGridFooterRowComponent,
  ElTreeGridHeaderRowComponent,
  ElTreeGridRowComponent,
} from './tree-grid-row.component';
import {
  ElTreeGridCellDirective,
  ElTreeGridFooterCellDirective,
  ElTreeGridHeaderCellDirective,
} from './tree-grid-cell.component';
import {
  ElSortDirective,
  ElSortHeaderComponent,
  ElSortHeaderIconDirective,
  ElSortIconComponent,
} from './tree-grid-sort.component';
import { ElTreeGridDataSourceBuilder } from './data-source/tree-grid-data-source';
import { ElTreeGridSortService } from './data-source/tree-grid-sort.service';
import { ElTreeGridFilterService } from './data-source/tree-grid-filter.service';
import { ElTreeGridService } from './data-source/tree-grid.service';
import { ElTreeGridDataService } from './data-source/tree-grid-data.service';
import { ElFilterDirective, ElFilterInputDirective } from './tree-grid-filter';
import { ElTreeGridRowToggleDirective } from './tree-grid-row-toggle.directive';
import { ElTreeGridColumnDefDirective } from './tree-grid-column-def.directive';
import { ElTreeGridRowToggleComponent } from './tree-grid-row-toggle.component';

const COMPONENTS = [
  // Tree Grid
  ElTreeGridComponent,

  ElTreeGridRowDefDirective,
  ElTreeGridRowComponent,
  ElTreeGridCellDefDirective,
  ElTreeGridCellDirective,

  ElTreeGridHeaderRowDefDirective,
  ElTreeGridHeaderRowComponent,
  ElTreeGridHeaderCellDefDirective,
  ElTreeGridHeaderCellDirective,

  ElTreeGridFooterRowDefDirective,
  ElTreeGridFooterRowComponent,
  ElTreeGridFooterCellDefDirective,
  ElTreeGridFooterCellDirective,

  ElTreeGridColumnDefDirective,

  // Sort directives
  ElSortDirective,
  ElSortHeaderComponent,
  ElSortIconComponent,

  // Filter directives
  ElFilterDirective,
  ElFilterInputDirective,

  ElTreeGridRowToggleDirective,
  ElTreeGridRowToggleComponent,
  ElSortHeaderIconDirective,
];

@NgModule({
  imports: [ CommonModule, ElTableModule, ElIconModule ],
  declarations: [ ...COMPONENTS ],
  exports: [ ElTableModule, ...COMPONENTS ],
  providers: [
    ElTreeGridSortService,
    ElTreeGridFilterService,
    ElTreeGridService,
    ElTreeGridDataService,
    ElTreeGridDataSourceBuilder,
  ],
})
export class ElTreeGridModule {}
